import React from 'react';

import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';
import { chatTargetsPropType } from 'app/shared/components/TeamChat/hooks/useLoanChatTargets/constants';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FINANCIAL_INFO_VIEWS_PATHS } from '../FinancialInfo.constants';

import { emptyMessageCellStyles } from './FinancialInfoBody.styles';

const COLUMNS_EXPANDED = 7;
const COLUMNS_MEDIUM = 6;
const COLUMNS_COLLAPSED = 5;

export const TablePropTypes = {
  tableName: PropTypes.oneOf(Object.values(FINANCIAL_INFO_VIEWS_PATHS)).isRequired,
  onToggle: PropTypes.func.isRequired,
  borrowerId: PropTypes.string,
  chatTargets: chatTargetsPropType,
  ...WithLoadingPropTypes,
};

const getNotFoundTableData = (tableName, colSpan, config) => {
  const usedConfig = _.pickBy(config, ({ isHidden }) => !isHidden);
  const index = 0;
  const key = Object.keys(usedConfig)[index];

  return [
    {
      [key]: {
        position: index + 1,
        customStyles: emptyMessageCellStyles,
        colSpan,
        content: (
          <NoAvailableMessage
            className="empty-message-row"
            message={`Sorry but we could not find ${tableName} data for this borrower(s)`}
          />
        ),
      },
    },
  ];
};

export const FINANCIAL_INFO_TABLE_NAME = {
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: 'Assets',
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: 'Employment & Income',
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: 'REO',
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: 'Liabilities',
};

export const getDataWithNotFoundMessage = config => ({
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: getNotFoundTableData(
    FINANCIAL_INFO_TABLE_NAME[FINANCIAL_INFO_VIEWS_PATHS.ASSETS],
    COLUMNS_EXPANDED,
    config,
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: getNotFoundTableData(
    FINANCIAL_INFO_TABLE_NAME[FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT],
    COLUMNS_MEDIUM,
    config,
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: getNotFoundTableData(
    FINANCIAL_INFO_TABLE_NAME[FINANCIAL_INFO_VIEWS_PATHS.REO],
    COLUMNS_COLLAPSED,
    config,
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: colspan =>
    getNotFoundTableData(
      FINANCIAL_INFO_TABLE_NAME[FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES],
      colspan,
      config,
    ),
});
